import { IDropdown } from "./interface";
import { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { STANDARD_HEIGHT_OF_DROPDOWN } from "../../utils/constants";
import { thinDarkScrollbar } from "../../utils/scrollbarStyles";
const Dropdown = ({
  label,
  selectedOption = {
    label: "",
    value: "",
  },
  options,
  onChange,
  showJustOptions = false,
}: IDropdown) => {
  const [value, setValue] = useState(selectedOption.value);

  useEffect(() => {
    setValue(selectedOption.value);
  }, [selectedOption]);

  const handleChange = (event: any) => {
    const selectedItem = options.find(
      (option) => option.value === event.target.value
    );
    onChange(selectedItem);
    setValue(event.target.value);
  };

  const theme = createTheme({
    typography: {
      fontFamily: "karla, sans-serif",
      fontSize: 14,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <FormControl style={{ width: "265px", marginLeft: "6px" }}>
        {label && <InputLabel>{label}</InputLabel>}
        {!showJustOptions && (
          <Select
            value={value}
            onChange={handleChange}
            displayEmpty
            IconComponent={(props) => (
              <KeyboardArrowDownIcon
                {...props}
                sx={{ color: "#1C2B36", fontSize: 30 }}
              />
            )}
            sx={{
              height: "42px",
              backgroundColor: "#FAFBFC",
              borderBottom: "1px solid #1C2B36",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: STANDARD_HEIGHT_OF_DROPDOWN,
                  overflowY: "auto",
                  ...thinDarkScrollbar,
                },
              },
            }}
          >
            {options.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
                {item.secondaryLabel !== undefined &&
                  item.secondaryLabel !== null && (
                    <span style={{ marginLeft: "8px" }}>
                      ({item.secondaryLabel})
                    </span>
                  )}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </ThemeProvider>
  );
};

export default Dropdown;
